<div class="chargement-container">
  <div class="loader_container">
    <div class="loader">
      <!-- `src` et non `ngSrc` : `NgOptimizedImage` n apporte rien a une image
           locale et statique, et exige une taille connue. Retire de tout le
           depot avec ce lot. -->
      <img alt="" src="assets/img/backstage-logo-no-ball.svg" />
    </div>
  </div>
</div>
